// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navrail {
    height: 100%;
    background-color: #ffffff;
    color: #000;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: absolute;
    top: 41px;
    left: 0;
    z-index: 100;
    transition: width 0.3s ease;
}

.navrail--collapsed {
    width: 45px;
    align-items: center;
}

.navrail--expanded {
    width: 0px;
    align-items: stretch;
}

.navrail-row {
    display: flex;
    align-items: center;
    margin-top: 13px;
}

.navrail-row:first-child {
    margin-top: 5px;
    padding-top: 0px;
}

.navrail--collapsed .navrail-row {
    flex-direction: column;
    justify-content: center;
    width: 100%;
}

.navrail--expanded .navrail-row {
    flex-direction: row;
    padding-left: 4px;
}

.navrail-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
}

.navrail--collapsed .navrail-icon-wrap {
    width: 100%;
}

.navrail-icon {
    font-size: 22px !important;
    padding: 6px;
    border-radius: 6px;
    width: 36px !important;
    height: 36px !important;
    background: #fff;
    color: #555;
    box-sizing: border-box;
    transition: all 0.2s ease;
}

.navrail-icon--active {
    background: #ED6926;
    color: #fff;
}

.navrail-label {
    padding-left: 14px;
    font-size: 14px;
    color: #222;
    white-space: nowrap;
    display: none !important;
}

.navrail--expanded .navrail-label {
    display: block;
}

.navrail-row--logout {
    margin-top: auto;
    margin-bottom: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IAEI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".navrail {\n    height: 100%;\n    background-color: #ffffff;\n    color: #000;\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    position: absolute;\n    top: 41px;\n    left: 0;\n    z-index: 100;\n    transition: width 0.3s ease;\n}\n\n.navrail--collapsed {\n    width: 45px;\n    align-items: center;\n}\n\n.navrail--expanded {\n    width: 0px;\n    align-items: stretch;\n}\n\n.navrail-row {\n    display: flex;\n    align-items: center;\n    margin-top: 13px;\n}\n\n.navrail-row:first-child {\n    margin-top: 5px;\n    padding-top: 0px;\n}\n\n.navrail--collapsed .navrail-row {\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n}\n\n.navrail--expanded .navrail-row {\n    flex-direction: row;\n    padding-left: 4px;\n}\n\n.navrail-icon-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.navrail--collapsed .navrail-icon-wrap {\n    width: 100%;\n}\n\n.navrail-icon {\n    font-size: 22px !important;\n    padding: 6px;\n    border-radius: 6px;\n    width: 36px !important;\n    height: 36px !important;\n    background: #fff;\n    color: #555;\n    box-sizing: border-box;\n    transition: all 0.2s ease;\n}\n\n.navrail-icon--active {\n    background: #ED6926;\n    color: #fff;\n}\n\n.navrail-label {\n    display: none;\n    padding-left: 14px;\n    font-size: 14px;\n    color: #222;\n    white-space: nowrap;\n    display: none !important;\n}\n\n.navrail--expanded .navrail-label {\n    display: block;\n}\n\n.navrail-row--logout {\n    margin-top: auto;\n    margin-bottom: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
